import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  RadioContainer,
  TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import {
  getAgeingAnalysisReportAction,
  resetAgeingAnalysisList,
  resetReportsError,
  resetReportsFetching,
  resetReportsSuccess,
} from "../../../redux/reports";
import { AgeingAnalysisReportPayloadType } from "../../../commonTypes/reportsTypes";
import { BalanceSheetImage } from "../../../assets/images";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import AgeingAnalysisTable from "../../../components/Reports/AgeingAnalysis/AgeingAnalysisTable";
import { AGEING_ANALYSIS_TABLE_HEADERS } from "../../../constant/tableHeadersConstants/reportsConstant/ageingAnalysisConstant/ageingAnalysisConstant";
import AgeingAnalysisSorting from "../../../components/Reports/AgeingAnalysis/AgeingAnalysisSorting";
import { AgeingAnalysisReportListType } from "../../../redux/reports/reportsType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { Excel } from "../../../components/Icon";
import { downloadAgeingAnalysisReportApi } from "../../../apis/reportsApis";
import toast from "react-hot-toast";
import FileSaver from "file-saver";

const AGEING_ANALYSIS_TYPE_OPTIONS: RadioTypes[] = [
  {
    id: "2",
    name: "Expense",
  },
  {
    id: "1",
    name: "Sales",
  },
];
type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  currencySign: string | undefined;
  ageingAnalysisList: AgeingAnalysisReportListType[] | [];
  totalCount: number;
  ageingAnalysis0To30DaysTotal: number;
  ageingAnalysis30To60DaysTotal: number;
  ageingAnalysis60To90DaysTotal: number;
  ageingAnalysisMoreThan90DaysTotal: number;
  ageingAnalysisTotalOfTotal: number;
  dispatchGetAgeingAnalysisReportAction: (
    data: AgeingAnalysisReportPayloadType
  ) => void;
  dispatchResetSession: () => void;
  dispatchResetAgeingAnalysisList: () => void;
  dispatchResetReportsErrorAction: () => void;
  dispatchResetReportsSuccessAction: () => void;
  dispatchResetReportsFetchingAction: () => void;
};
const AgeingAnalysisReport = ({
  history,
  token,
  fetching,
  statusCode,
  error,
  success,
  ageingAnalysisList,
  totalCount,
  currencySign,
  ageingAnalysis0To30DaysTotal,
  ageingAnalysis30To60DaysTotal,
  ageingAnalysis60To90DaysTotal,
  ageingAnalysisMoreThan90DaysTotal,
  ageingAnalysisTotalOfTotal,
  dispatchGetAgeingAnalysisReportAction,
  dispatchResetSession,
  dispatchResetAgeingAnalysisList,
  dispatchResetReportsErrorAction,
  dispatchResetReportsSuccessAction,
  dispatchResetReportsFetchingAction,
}: AppProps) => {
  const clientCode = history?.location?.state?.client_code;
  const companyName = history?.location?.state?.company_name;
  const [type, setType] = useState(AGEING_ANALYSIS_TYPE_OPTIONS[0]?.id);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | AgeingAnalysisReportListType[]>([]);
  const [toggleSort, setToggleSort] = useState<boolean>(false);
  const [sortByLegalName, setSortByLegalName] = useState({
    name: "",
    value: "",
  });
  const [sortByLedgerNumber, setSortByLedgerNumber] = useState({
    name: "",
    value: "",
  });
  const [recently, setRecently] = useState({ name: "", value: "" });
  const [isDownloadAgeingAnalysisPresent, setIsDownloadAgeingAnalysisPresent] =
    useMenuCheck();

  const handleSetRadioValue = (radioValue: string) => {
    setOffset(0);
    setType(radioValue);
  };

  useEffect(() => {
    setIsDownloadAgeingAnalysisPresent(
      "Download Ageing Analysis Report",
      "menu"
    );
    dispatchResetAgeingAnalysisList();
    dispatchResetReportsErrorAction();
    dispatchResetReportsFetchingAction();
  }, []);

  useEffect(() => {
    if (ageingAnalysisList?.length === 0) {
      setData(ageingAnalysisList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...ageingAnalysisList]);
    } else {
      setData(ageingAnalysisList);
    }
    //eslint-disable-next-line
  }, [ageingAnalysisList]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        type: type,
        client_code: clientCode,
        limit,
        offset,
        sort_by: sortByLegalName?.name
          ? "legal_name"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : "legal_name",
        sort_by_value: sortByLegalName?.value
          ? sortByLegalName?.value
          : sortByLedgerNumber?.value
          ? sortByLedgerNumber?.value
          : "asc",
      };

      if (totalCount) {
        if (offset < totalCount) {
          dispatchGetAgeingAnalysisReportAction(finalData);
        }
      } else {
        dispatchGetAgeingAnalysisReportAction(finalData);
      }
    }
    //eslint-disable-next-line
  }, [offset, type]);

  useEffect(() => {
    setOffset(0);
    handleSorting({ name: "Legal Name - Ascending", value: "asc" });
  }, [type]);

  const handleRefreshData = () => {
    setOffset(0);
    if (token) {
      let finalData = {
        token,
        type: type,
        client_code: clientCode,
        limit,
        offset: 0,
        sort_by: sortByLegalName?.name
          ? "legal_name"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : "legal_name",
        sort_by_value: sortByLegalName?.value
          ? sortByLegalName?.value
          : sortByLedgerNumber?.value
          ? sortByLedgerNumber?.value
          : "asc",
      };

      dispatchGetAgeingAnalysisReportAction(finalData);
    }
  };
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (ageingAnalysisList?.length > 0) {
          if (!fetching && offset < totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [ageingAnalysisList]);

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
    //eslint-disable-next-line
  }, [success]);

  const handleSorting = (data: any) => {
    setOffset(0);
    if (
      data?.name === "Legal Name - Ascending" ||
      data?.name === "Legal Name - Descending"
    ) {
      setSortByLegalName(data);
      setSortByLedgerNumber({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Ledger Number - Ascending" ||
      data?.name === "Ledger Number - Descending"
    ) {
      setSortByLedgerNumber(data);
      setSortByLegalName({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else {
      setRecently(data);
      setSortByLegalName({ name: "", value: "" });
      setSortByLedgerNumber({ name: "", value: "" });
    }
  };

  useEffect(() => {
    dispatchResetReportsErrorAction();
    dispatchResetReportsSuccessAction();
    dispatchResetAgeingAnalysisList();
    setOffset(0);
    if (
      token &&
      (sortByLedgerNumber?.name || sortByLegalName?.name || recently?.name)
    ) {
      let finalData = {
        token,
        type: type,
        client_code: clientCode,
        limit,
        offset: 0,
        sort_by: sortByLegalName?.name
          ? "legal_name"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : sortByLedgerNumber?.name
          ? "ledger_number"
          : "legal_name",
        sort_by_value: sortByLegalName?.value
          ? sortByLegalName?.value
          : sortByLedgerNumber?.value
          ? sortByLedgerNumber?.value
          : "asc",
      };

      dispatchGetAgeingAnalysisReportAction(finalData);
    }
    //eslint-disable-next-line
  }, [sortByLedgerNumber, sortByLegalName, recently]);

  const renderDownloadGeneralLedgerToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Download Excel
      </Tooltip>
    );
  };
  const handleDownload = (params: any) => {
    let reportName = companyName
      ? companyName + "_" + "Ageing_Analysis_Report" + ".xlsx"
      : "report";
    downloadAgeingAnalysisReportApi(params).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };
  const handlePrepareDownload = () => {
    let params: any = {
      token,
      type: type,
      client_code: clientCode,
      sort_by: sortByLegalName?.name
        ? "legal_name"
        : sortByLedgerNumber?.name
        ? "ledger_number"
        : sortByLedgerNumber?.name
        ? "ledger_number"
        : "legal_name",
      sort_by_value: sortByLegalName?.value
        ? sortByLegalName?.value
        : sortByLedgerNumber?.value
        ? sortByLedgerNumber?.value
        : "asc",
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetReportsErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title="Ageing Analysis"
          company_name={companyName}
          client_code={clientCode}
        />
      </div>
      <div className="new-table-card mt-4">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "36px",
          }}
        >
          <div className="d-flex" style={{ alignItems: "center" }}>
            {/* FUTURE USE */}
            {/* <div className="col-md-6 pl-3 form-group d-flex flex-column">
              <label htmlFor="clientName">
                Client Name <span className="color-red">*</span>
              </label>
              <div>
                <input
                  name="title"
                  type="text"
                  className={`form-control`}
                  disabled
                  value={`${companyName}`}
                />
              </div>
            </div> */}
            <div className="ml-4">
              <label htmlFor="report" className="mb-2">
                Select Report Type
              </label>
              <RadioContainer
                optionsList={AGEING_ANALYSIS_TYPE_OPTIONS}
                handleSetRadioValue={handleSetRadioValue}
                radioValue={type}
                alignment="horizontal"
              />
            </div>
            <div style={{ marginLeft: "23px", marginBottom: "-24px" }}>
              <button className="btn btn-primary" onClick={handleRefreshData}>
                Refresh
              </button>
            </div>
          </div>
          <div className="mr-5">
            <AgeingAnalysisSorting
              setToggle={setToggleSort}
              toggle={toggleSort}
              selectedData={
                sortByLegalName?.value
                  ? sortByLegalName
                  : sortByLedgerNumber?.value
                  ? sortByLedgerNumber
                  : {
                      name: "Legal Name - Ascending",
                      value: sortByLegalName?.value,
                    }
              }
              handleSorting={handleSorting}
              history={history}
            />
          </div>
        </div>

        <hr className="mt-4 mb-4" style={{ width: "97%" }} />
        <div>
          {fetching && offset == 0 ? (
            <TableLoader Rows={7} ColumnPerRow={8} />
          ) : (
            <>
              {!!ageingAnalysisList?.length ? (
                <>
                  <div className="d-flex">
                    <div
                      className="d-flex flex-column mb-3"
                      style={{ flex: "22" }}
                    >
                      <h3 className="text-center">Ageing Analysis Reports</h3>
                      <div className="d-flex justify-content-center"></div>
                    </div>
                    <div
                      className="d-flex align-items-center mr-2"
                      style={{ flex: "1" }}
                    >
                      {isDownloadAgeingAnalysisPresent && (
                        <span
                          style={{ marginTop: "-15px", marginRight: "38px" }}
                        >
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={renderDownloadGeneralLedgerToolTip}
                          >
                            <button
                              style={{ border: "none" }}
                              onClick={handlePrepareDownload}
                            >
                              <Excel />
                            </button>
                          </OverlayTrigger>
                        </span>
                      )}
                    </div>
                  </div>
                  <AgeingAnalysisTable
                    tableData={data}
                    tableHeaders={AGEING_ANALYSIS_TABLE_HEADERS}
                    clientCode={clientCode}
                    companyName={companyName}
                    fetching={fetching}
                    offset={offset}
                    currencySign={currencySign}
                    ageingAnalysis0To30DaysTotal={ageingAnalysis0To30DaysTotal}
                    ageingAnalysis30To60DaysTotal={
                      ageingAnalysis30To60DaysTotal
                    }
                    ageingAnalysis60To90DaysTotal={
                      ageingAnalysis60To90DaysTotal
                    }
                    ageingAnalysisMoreThan90DaysTotal={
                      ageingAnalysisMoreThan90DaysTotal
                    }
                    ageingAnalysisTotalOfTotal={ageingAnalysisTotalOfTotal}
                  />
                </>
              ) : (
                <div className="p-5">
                  <EmptyListPage
                    title={`No Ageing analysis Reports Found!`}
                    text={""}
                    image={BalanceSheetImage}
                    imageWidth="30%"
                  />
                </div>
              )}
            </>
          )}
        </div>
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  success: state.reports.success,
  ageingAnalysisList: state.reports.ageingAnalysisList,
  totalCount: state.reports.ageingAnalysisTotalCount,
  currencySign: state.auth.currencySign,
  ageingAnalysis0To30DaysTotal: state.reports.ageingAnalysis0To30DaysTotal,
  ageingAnalysis30To60DaysTotal: state.reports.ageingAnalysis30To60DaysTotal,
  ageingAnalysis60To90DaysTotal: state.reports.ageingAnalysis60To90DaysTotal,
  ageingAnalysisMoreThan90DaysTotal:
    state.reports.ageingAnalysisMoreThan90DaysTotal,
  ageingAnalysisTotalOfTotal: state.reports.ageingAnalysisTotalOfTotal,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAgeingAnalysisReportAction: (
    data: AgeingAnalysisReportPayloadType
  ) => dispatch(getAgeingAnalysisReportAction(data)),
  dispatchResetAgeingAnalysisList: () => dispatch(resetAgeingAnalysisList()),
  dispatchResetReportsErrorAction: () => dispatch(resetReportsError()),
  dispatchResetReportsSuccessAction: () => dispatch(resetReportsSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetReportsFetchingAction: () => dispatch(resetReportsFetching()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgeingAnalysisReport);
